import { ICellRendererParams } from "ag-grid-community";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { updateIsRuleFiltersApplied } from "@features/filtersSlice";
import { getActiveModule } from "@ts/utils";
import { FaLink } from "react-icons/fa";
import { ParentModule, Platforms } from "@/ts/common-types";

const NameCellRenderer = (params: ICellRendererParams) => {
    const dispatch = useDispatch();
    const data = params.data;
    const module = data.module;
    const { activeModule } = getActiveModule();
    const redLink = () => {
        if (module) {
            if (module.split("").includes("-")) {
                return `/${module}`;
            } else {
                return `/${Platforms.ACTIVATION}/${ParentModule.PERFORMANCE_OVERVIEW}/${module}`;
            }
        } else {
            return "#";
        }
    };

    const redirectClickHandler = () => {
        dispatch(updateIsRuleFiltersApplied(true));
        sessionStorage.setItem(
            "tabRedirection",
            JSON.stringify({ module: data.module, filter: data.filter })
        );
    };

    return (
        <>
            {params.node.rowPinned ? null : (
                <Link
                    to={redLink()}
                    style={{
                        cursor: "pointer",
                        textDecoration: "none",
                        color: "#000000",
                    }}
                    onClick={redirectClickHandler}
                >
                    {activeModule === ParentModule.RULES ? (
                        <span>
                            <FaLink style={{ color: "gray", opacity: "0.7" }} />{" "}
                            {data.name}
                        </span>
                    ) : (
                        <button
                            type="button"
                            className="btn btn-primary btn-rounded btn-sm"
                            id="view-rule-btn"
                        >
                            View
                        </button>
                    )}
                </Link>
            )}
        </>
    );
};

export default NameCellRenderer;
